import classNames from 'classnames';
import React from 'react';

import {InDemandCareerWrapper} from '@udemy/career-academies';
import {useI18n} from '@udemy/i18n';

import styles from './in-demand-careers.module.less';

export function InDemandCareers(props: React.ComponentProps<typeof InDemandCareerWrapper>) {
    const {gettext} = useI18n();

    const headingProps = {className: styles['in-demand-careers-heading']};

    return (
        <div className={styles['exploration-container']}>
            <div className={classNames('ud-container', styles['exploration-heading'])}>
                <h2 className={'ud-heading-xxl'}>{gettext('Not the right fit for you?')}</h2>
            </div>
            <InDemandCareerWrapper
                headingProps={headingProps}
                className={styles['in-demand-careers']}
                {...props}
            />
        </div>
    );
}
